import { ReactNode } from "react";
import { styles } from "./styles";

type Props = {
  children: ReactNode;
};

export default function RightColumn({ children }: Props) {
  return <styles.MainContainer>{children}</styles.MainContainer>;
}
